import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import DynamicForm from "../components/DynamicForm";
import { SampleDynamicForm } from "../constants/proposalConstants";
import {
  filterRuntimeFormData,
  fetchRuntimeFormData,
  fetchRuntimeFormDetails,
  postRuntimeFormData,
  filterRuntimeFormDataWithId,
  patchFormData,
} from "../services/FormService";
import CONSTANTS, {
  PRODUCT_CODES_FORM_ID,
  FireLossofProfit_FormId,
  PRODUCT_CATEGORY_FORM_ID,
  FORMS_ERROR_MSG,
  PROPOSAL_STATUS,
  USER_GROUPS,
  Create_Proposal_Error_Label,
  handleStepStatus,
  CLIENT_REGISTRATION_FORM_ID,
} from "../constants/constants";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Form } from "react-formio";
import { ResponseProps } from "../services/request";
import { useDispatch, useSelector } from "react-redux";
import {
  USER_GROUP,
  pushNotification,
  setProposalData,
} from "../redux/actions";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { fetchUsersWithGroup } from "../services/UserService";
import { useNavigate } from "react-router-dom";
import DataLoader from "../animations/LoadingCube.json";
import Lottie from "lottie-react";
import ClientLogo from "../assets/svg/Techsophy-logo.svg";
import Colors from "../theme/colors.json";
import CategoryCards from "./CategoryCards";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveIcon from "@mui/icons-material/Save";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const useStyles = makeStyles((theme) => ({
  addProposalMainContainer: {
    display: "flex",
    justifyContent: "center",
  },
  addProposalContainer: {
    display: "flex",
    flexDirection: "column",
    width: "83%",
    gap: 20,
    "@media (min-width: 2000px)": {
      paddingTop: "3%",
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      paddingTop: "3%",
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      paddingTop: "3.2%",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      paddingTop: "7%",
    },
    "@media (max-width: 600px)": {
      paddingTop: "10%",
    },
    fontSize: theme.fontSizes.SMALL,
  },
  productSection: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  productSectionHeading: {
    fontSize: "26px",
    fontWeight: 700,
    lineHeight: "19px",
    color: theme.palette.primary.main,
  },
  // productSectionForm: {
  //   display: "flex",
  //   flexDirection: "row",
  //   flexWrap: "wrap",
  //   gap: "2%",
  //   // rowGap: 20,
  //   width: "100%",
  // },

  productFormFieldContainer: {
    display: "flex",
    flexDirection: "column",
    width: "49%",
    gap: 5,
  },
  inputLabel: {
    fontSize: theme.fontSizes.MEDIUM,
    fontWeight: 600,
    color: theme.palette.secondary.main,
  },
  input: {
    width: "100%",
    background: Colors.WHITE_BACKGROUND,
    borderRadius: "0.3rem",
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      border: "none",
      padding: "0",
    },
  },
  clientSection: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  clientSectionHeading: {
    fontSize: "26px",
    fontWeight: 700,
    lineHeight: "19px",
    color: theme.palette.primary.main,
  },
  clientSectionForm: {},
  proposalSubmitBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // gap: 30,
    flexWrap: "wrap",
    position: "sticky",
    bottom: "0",
    width: "100%",
    marginBottom: "1%",
    padding: "0.6%",
    backgroundColor: Colors.WHITE_BACKGROUND,
    borderRadius: 5,
    "&:hover": {
      backgroundColor: Colors.INSUR_BG,
      borderRadius: 0,
    },
  },
  proposalActionsContainer: {
    justifyContent: "center !important",
  },
  assigneeField: {
    minWidth: 370,
  },
  loader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  createProposalSuggestionText: {
    display: "flex",
    justifyContent: "center",
    fontSize: "1.3rem",
    fontWeight: 300,
    // color: theme.palette.primary.main,
  },
  proposalSubmitBtnSection: {
    display: "flex",
    justifyContent: "center",
    gap: "10%",
  },
  btnBackground: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: Colors.WHITE_BACKGROUND,
    },
  },
  submitBtn: {
    textTransform: "capitalize",
  },
  formioFormContainer: {
    fontSize: theme.fontSizes.SMALL,
  },
  autocompleteInputStyle: {
    fontSize: theme.fontSizes.SMALL,
    height: "0.063rem !important",
  },
  // styles for category card tiles
  productSectionForm: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "1.2rem",
  },
  cardTitleSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "space-around",
    gap: "10px",
  },
  cardMainTitle: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: theme.fontSizes.XLARGE,
  },
  cardSubTitle: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    fontWeight: 400,
    fontSize: theme.fontSizes.MEDIUM,
    visibility: "hidden",
  },
  backBtn: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    zIndex: 1,
    position: "absolute",
    // height: "2.4%",
  },
  formioForm: {
    position: "relative",
  },
}));

const AddProposal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));

  const { userGroup } = useSelector((state: any) => ({
    userGroup: state.userGroup,
  }));

  const { userId } = useSelector((state: any) => ({
    userId: state.userId,
  }));

  const { proposalCreatedId } = useSelector((state: any) => ({
    proposalCreatedId: state.proposalCreatedId,
  }));

  const ProposalRefTag: any = useRef(null);

  const [productCategories, setProductCategories] = useState([]);
  const [productCodes, setProductCodes] = useState<any>([]);
  const [productTitle, setProductTitle] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productCode, setProductCode] = useState({
    productCode: null,
    productTitle: "",
    proposalFormId: "",
    productStatus: "",
  });

  const [proposalFormData, setProposalFormData] = useState({});
  const [proposalForm, setProposalForm] = useState<any>({});

  const [formRecordId, setFormRecordId] = useState("");
  const [formId, setFormId] = useState("");
  const [proposalStatus, setProposalStatus] = useState("");
  const [assigneeData, setAssigneeData] = useState<any>({});
  const [userData, setUserData] = useState<any>([
    {
      userId: "",
      fullName: "",
    },
  ]);

  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleAssigneeSubmit = () => {
    if (assigneeData?.userId) {
      checkFormSubmission(PROPOSAL_STATUS.UNDERREVIEW);
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: "Please Select the Assignee",
      });
    }
  };

  const checkFormSubmission = async (status) => {
    setProposalStatus(status);
    if (ProposalRefTag?.current) {
      ProposalRefTag.current.formio.submit();
    } else {
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: FORMS_ERROR_MSG,
      });
      return;
    }
  };

  const handleProductCategoryChange = (data) => {
    const { name, value } = data;
    setProductCategory(value);
    setProductCode({
      productCode: null,
      productTitle: "",
      proposalFormId: "",
      productStatus: "",
    });
    setProductTitle("");
    handleGetProductCodes(name, value, PRODUCT_CODES_FORM_ID);
    setFormId("");
    setFormRecordId("");
    setProposalFormData({});
    setProposalForm({});
    dispatch(setProposalData({}));
  };

  const handleProductCodeChange = (data) => {
    const { name, value } = data;
    setProductCode(value);
    setProductTitle(value.productTitle);
    handleGetProposalForm(value.proposalFormId);
    setFormId(value.proposalFormId);
    setFormRecordId("");
    setProposalFormData({});
    setProposalForm({});
    dispatch(setProposalData({}));
  };

  const getProductCategories = async () => {
    const response = await fetchRuntimeFormData(
      PRODUCT_CATEGORY_FORM_ID,
      0,
      10000
    );

    const filteredProductCategories = response?.data?.content?.map((item) => {
      return item?.formData?.productCategory;
    });

    setProductCategories(filteredProductCategories || []);
  };

  const handleGetProductCodes = async (key, value, id) => {
    const response = await filterRuntimeFormData(id, key, value);
    if (response?.success) {
      const filteredProductCodes = response?.data?.map((item) => {
        return {
          productCode: item?.formData?.productCode,
          productTitle: item?.formData?.productTitle,
          proposalFormId: item?.formData?.proposalFormId,
          productStatus: item?.formData?.productStatus,
        };
      });

      setProductCodes(filteredProductCodes);
    } else {
      setProductCodes([]);
    }
  };

  const handleGetProposalForm = async (formId) => {
    const response: any = await fetchRuntimeFormDetails(formId);
    if (response.success) {
      setProposalForm(response?.data?.components);
    } else {
      setProposalForm({ display: "form", components: [] });
    }
  };

  const navigateUserToProposalList = () => {
    if (
      assigneeData?.userId !== proposalDataRedux?.formData?.assignedTo &&
      userId !== (proposalCreatedId || userId) &&
      userGroup !== USER_GROUPS.ADMIN
    ) {
      navigate(`${process.env.PUBLIC_URL}/proposalList`);
    }
  };

  const handleFormSubmit = async (submission) => {
    setIsLoading(true);
    if (formRecordId) {
      const body = {
        formId: formId,
        id: formRecordId,
        formData: {
          ...submission?.data,
          productCategory: productCategory,
          productCode: parseInt(productCode.productCode || ""),
          productTitle: productTitle,
          productStatus: productCode.productStatus,
          underwriterDetails: {
            ...proposalDataRedux?.formData?.underwriterDetails,
          },
          proposalStatus: handleStepStatus(
            proposalDataRedux?.formData?.proposalStatus,
            proposalStatus
          ),
          assignedTo: assigneeData?.userId,
        },
      };
      const response: any = await patchFormData(body);
      if (response?.success) {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );

        dispatch(
          setProposalData({
            id: body?.id,
            formId: body?.formId,
            formData: body?.formData,
          })
        );
        setIsLoading(false);
        handleClose();
        navigateUserToProposalList();
      } else {
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
        setIsLoading(false);
      }
    } else {
      const body = {
        formId: formId,
        formData: {
          ...submission?.data,
          productCategory: productCategory,
          productCode: productCode.productCode,
          productTitle: productTitle,
          productStatus: productCode.productStatus,
          underwriterDetails: {},
          proposalStatus: handleStepStatus(
            proposalDataRedux?.formData?.proposalStatus,
            proposalStatus
          ),
          assignedTo: assigneeData?.userId,
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setFormRecordId(response?.data?.id);
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );

        dispatch(
          setProposalData({
            id: response?.data?.id,
            formId: body?.formId,
            formData: body?.formData,
          })
        );
        setIsLoading(false);
        handleClose();
        navigateUserToProposalList();
      } else {
        setFormRecordId("");
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
        setIsLoading(false);
      }
    }
  };

  const handleGetUsers = async () => {
    const response = await fetchUsersWithGroup(
      USER_GROUPS.UNDERWRITER.replace("/", "")
    );
    if (response.success) {
      setUserData(
        response?.data || [
          {
            userId: "",
            fullName: "",
          },
        ]
      );

      const filteredUser = response?.data?.filter((userData) => {
        return userData?.userId === proposalDataRedux?.formData?.assignedTo;
      });

      setAssigneeData(filteredUser[0]);
    } else {
      setUserData([
        {
          userId: "",
          fullName: "",
        },
      ]);
    }
  };

  // const getPrefillFormData = async (formId, id) => {
  //   const response = await filterRuntimeFormDataWithId(formId, id);
  //   console.log(response);
  //   if (response?.success)
  //     setProposalFormData({
  //       data: { ...response?.data[0]?.formData },
  //     });
  // };

  const handleGetPrefillData = () => {
    handleGetProductCodes(
      "productCategory",
      proposalDataRedux?.formData?.productCategory,
      PRODUCT_CODES_FORM_ID
    );
    setProductCategory(proposalDataRedux?.formData?.productCategory);
    setProductCode({
      productCode: proposalDataRedux?.formData?.productCode || null,
      productTitle: proposalDataRedux?.formData?.productTitle || "",
      proposalFormId: proposalDataRedux?.formId || "",
      productStatus: proposalDataRedux?.formData?.productStatus || "",
    });
    setProductTitle(proposalDataRedux?.formData?.productTitle);
    handleGetProposalForm(proposalDataRedux?.formId);
    setFormId(proposalDataRedux?.formId);
    setFormRecordId(proposalDataRedux?.id);
    setProposalFormData({ data: { ...proposalDataRedux?.formData } });
    setProposalStatus(proposalDataRedux?.formData?.proposalStatus);

    // getPrefillFormData(proposalDataRedux?.formId, proposalDataRedux?.id);
  };

  const handleFormOnchange = (schema) => {
    if (schema?.data?.insuredName) {
      handleGetCommunicationAddress(schema?.data?.insuredName);
    }
  };

  const handleGetCommunicationAddress = async (insuredName) => {
    const response = await filterRuntimeFormData(
      CLIENT_REGISTRATION_FORM_ID,
      "clientName",
      insuredName
    );
    if (response?.success) {
      setProposalFormData((prevState: any) => ({
        ...prevState,
        data: {
          ...prevState.data,
          communicationAddress: response?.data[0]?.clientCommunicationAddress,
        },
      }));
    } else {
      setProposalFormData((prevState: any) => {
        return {
          data: {
            ...prevState?.data,
            communicationAddress: "",
          },
        };
      });
    }
  };

  const handleBackNavigation = () => {
    if (
      proposalDataRedux?.formId &&
      proposalDataRedux?.id &&
      Object.keys(proposalDataRedux?.formData)?.length > 0
    ) {
      setProductCode({
        productCode: null,
        productTitle: "",
        proposalFormId: "",
        productStatus: "",
      });
      setProductTitle("");
      // handleGetProductCodes(name, value, PRODUCT_CODES_FORM_ID);
      setFormId("");
      setFormRecordId("");
      setProposalFormData({});
      setProposalForm({});
      dispatch(setProposalData({}));
      navigate(`${process.env.PUBLIC_URL}/proposalList`);
    } else {
      setProductCode({
        productCode: null,
        productTitle: "",
        proposalFormId: "",
        productStatus: "",
      });
      setProductTitle("");
      // handleGetProductCodes(name, value, PRODUCT_CODES_FORM_ID);
      setFormId("");
      setFormRecordId("");
      setProposalFormData({});
      setProposalForm({});
      dispatch(setProposalData({}));
    }
  };

  useEffect(() => {
    getProductCategories();
    handleGetPrefillData();
    handleGetUsers();
  }, []);

  // useEffect(() => {
  //   // setNextDisable(Boolean(Object.keys(proposalDataRedux).length === 0));
  //   if (proposalStatus) {
  //     setSubmitDisable(false);
  //     setSaveDisable(true);
  //     setNextDisable(false);
  //   }
  // }, [proposalStatus, proposalDataRedux]);

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-assigne"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-assigne">
          Please Select the Assignee
        </DialogTitle>

        <DialogContent dividers>
          <Autocomplete
            className={classes.assigneeField}
            id="proposal-assignee"
            options={userData}
            getOptionLabel={(option: any) => option?.fullName || ""}
            value={assigneeData}
            onChange={(_, newValue: any) => setAssigneeData(newValue)}
            disableClearable={true}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                inputProps={{
                  ...params.inputProps,
                  className: classes.autocompleteInputStyle,
                }}
              />
            )}
          />
        </DialogContent>
        <DialogActions className={classes.proposalActionsContainer}>
          <Button
            className={classes.btnBackground}
            variant="outlined"
            color="primary"
            onClick={handleAssigneeSubmit}
          >
            Submit
          </Button>
          <Button
            className={classes.btnBackground}
            variant="outlined"
            color="primary"
            onClick={handleClose}
          >
            Cancel/Close
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.addProposalMainContainer}>
        <div className={classes.addProposalContainer}>
          {/* <div className={classes.productSection}> */}
          {/* <div className={classes.productSectionHeading}>Product Section</div> */}

          {/* Code for Product Category tiles */}
          {!formId && (
            <>
              <div className={classes.productSectionForm}>
                <div className={classes.cardTitleSection}>
                  {/* <div className={classes.cardMainTitle}>Create Proposal</div> */}
                  <div className={classes.cardSubTitle}>
                    {Create_Proposal_Error_Label}
                  </div>
                </div>
                <div>
                  <CategoryCards
                    options={productCategories}
                    onSelect={handleProductCategoryChange}
                    productCodes={productCodes}
                    handleProductCodeChange={handleProductCodeChange}
                    productCategory={productCategory}
                    setProductCodes={setProductCodes}
                  />
                </div>
              </div>
            </>
          )}
          {/* End Code for Product Category tiles */}

          {/* <div className={classes.productFormFieldContainer}>
                <label className={classes.inputLabel}>Product Category</label>
                <Autocomplete
                  id="product-category"
                  className={classes.input}
                  options={productCategories}
                  getOptionLabel={(option) => option}
                  value={productCategory}
                  onChange={(_, newValue: any) =>
                    handleProductCategoryChange({
                      name: "productCategory",
                      value: newValue,
                    })
                  }
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        className: classes.autocompleteInputStyle,
                      }}
                    />
                  )}
                />
              </div>
              <div className={classes.productFormFieldContainer}>
                <label className={classes.inputLabel}>Product Title</label>
                <Autocomplete
                  id="product-code"
                  className={classes.input}
                  options={productCodes}
                  getOptionLabel={(option: any) =>
                    option?.productTitle?.toString() || ""
                  }
                  getOptionDisabled={(option) =>
                    option.productStatus === "InActive"
                  }
                  value={productCode}
                  onChange={(_, newValue: any) =>
                    handleProductCodeChange({
                      name: "productCode",
                      value: newValue,
                    })
                  }
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        className: classes.autocompleteInputStyle,
                      }}
                    />
                  )}
                />
              </div> */}
          {/* <div className={classes.productFormFieldContainer}>
              <label className={classes.inputLabel}>Product Type</label>
              <TextField
                id="product-title"
                className={classes.input}
                value={productTitle}
                size="small"
              />
            </div> */}
          {/* </div> */}
          {/* </div> */}
          {Object.keys(proposalForm)?.length === 0 &&
            Object.keys(proposalFormData)?.length === 0 &&
            formId && (
              <Box className={classes.loader}>
                <Lottie animationData={DataLoader} loop={true} />
                {/* <CircularProgress size={80} />
              ...Please Wait */}
              </Box>
            )}
          <div className={classes.formioForm}>
            {proposalForm?.components?.length > 0 && (
              <div className={classes.backBtn}>
                <Tooltip title="Back">
                  <IconButton onClick={handleBackNavigation}>
                    <ArrowBackIosIcon color="primary" fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            {/* {formId && Object.keys(proposalForm)?.length > 0 && (
            <div className="techshophy-logo-container-addProposal">
              <img
                src={sessionStorage.getItem("logoURL") || ClientLogo}
                alt="client-logo"
              />
            </div>
          )} */}
            {proposalForm?.components?.length > 0 && (
              <Form
                ref={ProposalRefTag}
                form={proposalForm}
                submission={proposalFormData}
                // onChange={(schema: any) => console.log(schema)}
                onSubmit={(submission) => handleFormSubmit(submission)}
                className={classes.formioFormContainer}
              />
            )}
          </div>

          {formId && Object.keys(proposalForm)?.length > 0 && (
            <div className={classes.proposalSubmitBtnContainer}>
              <div className={classes.proposalSubmitBtnSection}>
                <Button
                  className={classes.btnBackground}
                  variant="outlined"
                  color="primary"
                  size="medium"
                  onClick={() => checkFormSubmission(PROPOSAL_STATUS.DRAFT)}
                  disabled={isLoading}
                  startIcon={<SaveIcon fontSize="medium" />}
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleClickOpen}
                  // disabled={submitDisable}
                  className={classes.submitBtn}
                  disabled={isLoading}
                  startIcon={<CheckCircleOutlineIcon fontSize="medium" />}
                >
                  Submit
                </Button>
              </div>
              <div>
                {userGroup === USER_GROUPS.BROKER ? null : (
                  <Button
                    className={classes.btnBackground}
                    variant="outlined"
                    color="primary"
                    size="medium"
                    onClick={() =>
                      navigate(`${process.env.PUBLIC_URL}/underwriterDetails`)
                    }
                    disabled={
                      !proposalDataRedux?.formData?.proposalStatus ||
                      proposalDataRedux?.formData?.proposalStatus ===
                        PROPOSAL_STATUS.DRAFT ||
                      isLoading ||
                      (userGroup === USER_GROUPS.ADMIN
                        ? false
                        : userId !== proposalDataRedux?.formData?.assignedTo)
                    }
                    endIcon={<NavigateNextIcon fontSize="medium" />}
                  >
                    Next
                  </Button>
                )}
              </div>
            </div>
          )}
          {/* {!formId && (
            <div className={classes.createProposalSuggestionText}>
              {Create_Proposal_Error_Label}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default AddProposal;
